import { Component, Input, OnInit } from '@angular/core';
import { SelectListNext, SelectListOption } from '@components';
import {
	DomainService,
	LanguageService,
	StorageService,
	TempKey,
} from '@services/public';
import { ReplaySubject } from 'rxjs';
import { ReflectionData, ReflectionPage } from '../common';

const PAGE_PATH: string = 'skillBuilders.reflection.pages.skill';

@Component({
	selector: 'app-member-skill-builder-reflection-skill',
	templateUrl: './skill.component.html',
	styleUrls: ['./skill.component.scss'],
})
export class MemberSkillBuilderReflectionSkillComponent implements OnInit {
	@Input() data: ReflectionData;
	options: ReplaySubject<Array<SelectListOption>> = new ReplaySubject<
		Array<SelectListOption>
	>(1);
	next: SelectListNext = {
		onClick: this.nextOnClick.bind(this),
	};

	// Page langauge.
	page: { [key: string]: string } = {
		title: '',
		subTitle2: '',
		noScore: '',
	};

	constructor(
		private _domainSvc: DomainService,
		private _languageSvc: LanguageService,
		private _storageSvc: StorageService,
	) {}

	async ngOnInit(): Promise<void> {
		// Get page language.
		await this._languageSvc
			.get([PAGE_PATH], {
				[PAGE_PATH]: {
					domain: this._domainSvc
						.getDomain(this.data.domainUID)
						.name.toLowerCase(),
				},
			})
			.then((value) => {
				if (typeof value[PAGE_PATH] === 'object' && value[PAGE_PATH] !== null)
					this.page = value[PAGE_PATH];
			});

		// Get options list.
		this.options.next(
			this.data.scores
				.sort((a, b) => {
					const aScore = a.peer ?? a.self;
					const bScore = b.peer ?? b.self;
					if (aScore === null) return 1;
					if (bScore === null) return -1;
					return aScore - bScore;
				})
				.map((score) => {
					return {
						display:
							`${this._domainSvc.getSkill(score.uid).name}: ` +
							((score.peer ?? score.self) === null
								? this.page.noScore
								: (score.peer ?? score.self).toFixed(1)),
						value: score.uid,
						selected: score.uid === this.data.skillUID,
					};
				}),
		);
	}

	nextOnClick(option: SelectListOption): void {
		this._storageSvc.setTempStorage(TempKey.REFLECTION, {
			...this.data,
			page: ReflectionPage.ACTION,
			skillUID: option.value,
		});
	}
}
